export default __webpack_public_path__ + "static/clementine-sandner-1f7b209eda8ce66476318b79941fa3e2.jpg";